import { Avatar } from "@mantine/core";
import { CSSProperties } from "react";
import dayjs from "dayjs";

interface CardProps {
  profile?: string | null;
  name?: string;
  email?: string;
  birthday?: string;
  businessAddress?: {
    city?: string;
    district?: string;
    address?: string;
  };
  telephone?: string;
}

interface CardComponentProps {
  props?: CardProps;
  onClick?: () => void;
  customStyle?: {
    baseStyle?: CSSProperties;
  };
}

const Card = ({ props, onClick, customStyle }: CardComponentProps) => {
  const {
    profile = "",
    name = "",
    email = "",
    birthday = "",
    businessAddress,
    telephone = "",
  } = props || {};

  const fullAddress = businessAddress
    ? `${businessAddress.city || ""}${businessAddress.district || ""}${businessAddress.address || ""}`
    : "";

  const line2 = email || fullAddress;
  const line3 = birthday ? dayjs(birthday).format("YYYY-MM-DD") : telephone;

  return (
    <div
      className="mx-4 my-4 flex max-w-md cursor-pointer flex-col rounded-lg bg-white p-3 shadow-lg md:mx-8 md:max-w-2xl md:flex-row"
      onClick={onClick}
      style={{ ...customStyle?.baseStyle, overflow: "hidden" }}
    >
      <div className="md:flex-3 relative flex w-full items-center justify-center md:w-auto md:flex-shrink-0">
        {profile ? (
          <img
            src={profile}
            alt={name}
            className="w-24 h-24 object-cover rounded-full"
          />
        ) : (
          <Avatar size="xl" key={name} name={name[0]} />
        )}
      </div>
      <div className="md:flex-7 w-full px-3 py-4 min-w-0">
        <div
          className="text-xl font-semibold text-black"
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {name}
        </div>
        {line2 && (
          <p
            className="mt-1 text-gray-600"
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {line2}
          </p>
        )}
        {line3 && (
          <p
            className="mt-1 text-gray-600"
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {line3}
          </p>
        )}
      </div>
    </div>
  );
};

export default Card;
